const inactiveReasons = [
    {
        id: "17",
        name: "Discharged"
    },
    {
        id: "58",
        name: "Discontinued"
    },
    {
        id: "16",
        name: "Do Not Supply"
    },
    {
        id: "18",
        name: "Expired"
    },
    {
        id: "15",
        name: "Hospital"
    },
    {
        id: "0",
        name: "None"
    }
];

export default inactiveReasons;

